module.exports = __webpack_public_path__ + "static/img/pt.d2adee5e.png";